import { render } from "./TermsOfServiceComponent.vue?vue&type=template&id=45b2945a&scoped=true"
import script from "./TermsOfServiceComponent.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceComponent.vue?vue&type=script&lang=js"

import "./TermsOfServiceComponent.vue?vue&type=style&index=0&id=45b2945a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b2945a"]])

export default __exports__